// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 984 ? "reactPlayerPreview" : chunkId) + "." + {"592":"078d5ce6","984":"2bcd2269"}[chunkId] + ".chunk.js";
};